/*
 *  Copyright © Microsoft Corporation. All rights reserved.
 */

import * as React from 'react';
import { getThemedIcon, IconName } from '../../../resources/icons/Icons';
import { ValidationTextField } from '../../../views/common';
import { MobileActionTableItem } from '../../components/MobileActionTableItem/MobileActionTableItem';
import { getMobileTextFieldStyles } from '../../components/MobileTextField/MobileTextField.styles';

interface EsignMobileOrderInputProps {
    order: string;
}

export const EsignMobileOrderInput: React.FC<EsignMobileOrderInputProps> = ({
    order,
}: EsignMobileOrderInputProps): JSX.Element => {
    const icon = getThemedIcon(IconName.textNumberList);

    const actionElement = (
        <div className='textfield-container'>
            <ValidationTextField
                value={order}
                defaultValue={order}
                styles={getMobileTextFieldStyles()}
                resizable={true}
                autoAdjustHeight={true}
                disabled={true}
            />
        </div>
    );

    return <MobileActionTableItem unselectedIcon={icon} selectedIcon={icon} actionElement={actionElement} />;
};
